<template>
<div>
        <userlikesmodal-component :idpost="idpost"/>
        <modalcomments-component :idpost="idpost" :iduser="iduser"/>
        <v-layout v-if="modalfile">
            <v-dialog max-width="1000" max-height="100%" v-model="modalfile" persistent>
                <button type="button" class="close" @click="closemodalfile">
                    <span style="color:black;font-size:30px" aria-hidden="true">&times;</span>
                </button>
                <v-container style="background:white" grid-list-xs text-xs-center>
                    <div class="embed-responsive embed-responsive-16by9">
                        <v-img 
                          class="embed-responsive-item"
                          v-if="typefilechoosed.split('/')[0] === 'image'"
                          :src="linkfilechoosed"
                      ></v-img>
                      <video
                          v-else-if="typefilechoosed.split('/')[0] === 'video' || typefilechoosed.split('/')[0] === 'audio'"
                          class="video-js embed-responsive-item"
                          controls
                          data-setup='{"language":"en"}'
                        >
                          <source :src="linkfilechoosed" :type="typefilechoosed.type">
                          <track kind="captions" src="http://example.com/path/to/captions.vtt" srclang="en" label="English" default>
                        </video>
                    </div>
                </v-container>
            </v-dialog>
        </v-layout>
        <v-layout row justify-center>
          <v-dialog v-model="modaldescriptionreport"  max-width="320px" persistent>
            <v-card>
              <div class="text-center">
                <v-textarea style="background:white;"
                  counter
                  v-model="commentdescriptionreport"
                  :label="language==='English'?'Write that you have the publication to be reported.':'Escribe que tiene la publicación para que sea reportado.'"
                ></v-textarea>
                <!--textarea v-model="commentdescriptionreport"  class="form-control" :placeholder="language==='English'?'Write that you have the publication to be reported.':'Escribe que tiene la publicación para que sea reportado.'"></textarea-->
              </div>
              <div class="text-center">
              <v-btn color="primary" @click="savereport">{{language==='English'?'Report':'Reportar'}}</v-btn>
              </div>
              <div class="text-center">
              <v-btn color="primary" @click="modaldescriptionreport = false">{{language==='English'?'Close':'Cerrar'}}</v-btn>
              </div>
            </v-card>
          </v-dialog>
        </v-layout>
        <!--div class="left-content" style="margin-top:28px">
        <div class="global-links">
            <a href="javascript:void(0)">
            <img src="//i.imgur.com/5jInimY.jpg" /> First Last
            <span class="counter">1</span>
            </a>
            <a class="activepage" href="javascript:void(0)">
            <img src="http://brassnecktheatre.com/wp-content/uploads/2013/11/news-icon.png" /> News Feed
            <span class="counter">
                <i class="fa fa-ellipsis-h"></i>
            </span>
            </a>
            <a href="javascript:void(0)">
            <img src="http://icons.iconarchive.com/icons/wineass/ios7-redesign/512/Messages-icon.png" /> Messenger
            <span class="counter">1</span>
            </a>
            <div class="group-content">
            <h4>shortcuts</h4>
            <a href="javascript:void(0)">
                <img src="http://theieltscoach.com/wp-content/uploads/2015/03/IELTS-Speaking-Tips-Icon-2.png" /> Group name
                <span class="counter">1</span>
            </a>
            <a href="javascript:void(0)">
                <img src="http://theieltscoach.com/wp-content/uploads/2015/03/IELTS-Speaking-Tips-Icon-2.png" /> Group name
                <span class="counter">1</span>
            </a>
            <a href="javascript:void(0)">
                <img src="http://theieltscoach.com/wp-content/uploads/2015/03/IELTS-Speaking-Tips-Icon-2.png" /> Group name
                <span class="counter">1</span>
            </a>
            <a href="javascript:void(0)">
                <img src="http://theieltscoach.com/wp-content/uploads/2015/03/IELTS-Speaking-Tips-Icon-2.png" /> Group name
                <span class="counter">1</span>
            </a>
            <a href="javascript:void(0)">
                <img src="http://theieltscoach.com/wp-content/uploads/2015/03/IELTS-Speaking-Tips-Icon-2.png" /> Group name
                <span class="counter">1</span>
            </a>
            <a href="javascript:void(0)">
                <i class="fa fa-caret-down"></i>
                <span>See More...</span>
            </a>
            </div>
            <div class="group-content">
            <h4>explore</h4>
            <a href="javascript:void(0)">
                <img src="http://icons.iconarchive.com/icons/paomedia/small-n-flat/1024/calendar-icon.png" /> Events
                <span class="counter">1</span>
            </a>
            <a href="javascript:void(0)">
                <img src="http://image.flaticon.com/icons/png/512/223/223120.png" /> Saved
                <span class="counter">1</span>
            </a>
            <a href="javascript:void(0)">
                <img src="http://icons.iconarchive.com/icons/custom-icon-design/pretty-office-13/512/Webpage-icon.png" /> Pages
                <span class="counter">1</span>
            </a>
            <a href="javascript:void(0)">
                <img src="https://www.iconfinder.com/data/icons/unique-round-blue/93/group-512.png" /> Groups
                <span class="counter">1</span>
            </a>
            <a href="javascript:void(0)">
                <img src="http://www.thesuccesswriter.com/images/fundraising.png" /> Fundraisers
            <span class="counter">1</span>
            </a>
            <a href="javascript:void(0)">
            <i class="fa fa-caret-down"></i>
            <span>See More...</span>
            </a>
        </div>
            <div class="group-content">
            <h4>create</h4>
            <a href="javascript:void(0)">
                <img src="http://1agb93314bcf1knhv22id9u9.wpengine.netdna-cdn.com/wp-content/uploads/2015/02/Marketing_Advertising_Icon.png" /> Ad
            </a>
            <a href="javascript:void(0)">
                <img src="http://icons.iconarchive.com/icons/custom-icon-design/pretty-office-13/512/Webpage-icon.png" /> Page
            </a>
            <a href="javascript:void(0)">
                <img src="https://www.iconfinder.com/data/icons/unique-round-blue/93/group-512.png" /> Group
            </a>
            <a href="javascript:void(0)">
                <img src="http://icons.iconarchive.com/icons/paomedia/small-n-flat/1024/calendar-icon.png" /> Event
            </a>
            <a href="javascript:void(0)">
                <img src="http://www.thesuccesswriter.com/images/fundraising.png" /> Fundraiser
            </a>
            </div>
        </div>
        </div-->
        <div class="feed-content" style="margin-top:28px;">
        <div class="recentcontainer" v-if="session">
            <ul class="newpostheader nav nav-tabs nav-justified">
            <li>
                <a href="javascript:void(0)">
                  <i class="fa fa-pencil-alt"></i>
                  <span>{{language==='English'?'Create a Post':'Crear Publicación'}}</span>
                </a>
            </li>
            <!--li>
                <a href="javascript:void(0)">
                <i class="fa fa-book"></i>
                <span>Media Album</span>
                </a>
            </li>
            <li>
                <a href="javascript:void(0)">
                <i class="fa fa-video-camera"></i>
                <span>Live Video</span>
                </a>
            </li-->
            </ul>
            <div class="newpost">
              <textarea v-model="newpost.description" :placeholder="language==='English'?'Post Something...':'Publica Algo...'"></textarea>
            </div>
            <ul class="newpostfooter nav nav-tabs nav-justified">
              <li v-if="!uploadingfile">
                  <a @click="pickFile">
                    <i class="fa fa-image"></i>
                    <span style="font-size:14px;">{{language==='English'?'Photo':'Foto'}}/Video/{{language==='English'?'File':'Archivo'}}</span>
                  </a>
              </li>
              <li>
                <!--label for="visibility">Elige la privacidad:</label-->
                <select class="custom-select" v-model="newpost.visibility" style="margin-left:10px" id="visibility">
                  <option :value="'privacy'" disabled>{{language==='English'?'Choose the privacy of your publication':'Elija la privacidad de su publicacion'}}</option>
                  <option :value="'public'">{{language==='English'?'Public':'Público'}}</option>
                  <option :value="'followers'">{{language==='English'?'Followers':'Seguidores'}}</option>
                </select>
              </li>
              <input
                type="file"
                style="display: none"
                ref="filepost"
                @change="onFilePicked"
            > 
              <!--li>
                  <a href="javascript:void(0)">
                  <i class="fa fa-smile-o"></i>
                  <span>Feeling/Activity</span>
                  </a>
              </li>
              <li>
                  <a href="javascript:void(0)">
                  <i class="fa fa-ellipsis-h"></i>
                  </a>
              </li-->
            </ul>
            <div
              v-if="filesexistoruploading"
              class="hidden-sm-only hidden-xs-only"
              style="width:100%; position:relative;"
            >
              <v-layout class="newpostfooter" row wrap>
                <v-flex md2 lg2 style="margin-left:30px;margin-top:10px" v-for="filesuploaded in filesuploaded" :key="filesuploaded.length">
                    <button type="button" class="close" @click="deletefile(filesuploaded._id)" style="position:absolute;z-index:5;background:black;">
                          <span style="color:white;font-size:30px" aria-hidden="true">&times;</span>
                    </button>
                    <video
                      v-if="filesuploaded.type.split('/')[0] === 'video' || filesuploaded.type.split('/')[0] === 'audio'"
                      :id="filesuploaded._id"
                      class="video-js"
                      style="width:150px;height:100px"
                      data-setup='{ "inactivityTimeout": 0 }'
                      @click="openmodalfile(filesuploaded.link,filesuploaded.type)"
                      controls
                    >
                      <source :src="filesuploaded.link" :type="filesuploaded.type">
                    </video>
                    <!--video-player 
                            v-if="filesuploaded.type.split('/')[0] === 'video' || filesuploaded.type.split('/')[0] === 'audio'"
                            ref="videoPlayer"
                            :options="playerOptions"
                            
                            :playsinline="true"
                            @play="onPlayerPlay($event)"
                            @pause="onPlayerPause($event)"
                            @ended="onPlayerEnded($event)"
                            @loadeddata="onPlayerLoadeddata($event)"
                            @waiting="onPlayerWaiting($event)"
                            @playing="onPlayerPlaying($event)"
                            @timeupdate="onPlayerTimeupdate($event)"
                            @canplay="onPlayerCanplay($event)"
                            @canplaythrough="onPlayerCanplaythrough($event)"
                            @ready="playerReadied"
                            @statechanged="playerStateChanged($event)">
                            <source :src="filesuploaded.link" :type="filesuploaded.type">
                    </video-player-->
                    <v-img 
                      v-else-if="filesuploaded.type.split('/')[0] === 'image'"
                      width='150'
                      height='100'
                      @click="openmodalfile(filesuploaded.link,filesuploaded.type)"
                      :src="filesuploaded.link"
                    ></v-img>
                    <div class="text-center" v-else>
                      <i class="fas fa-file" style="font-size:50px;margin-top:30px"></i>
                      <br>
                      <label>{{filesuploaded.name}}</label>
                    </div>
                  </v-flex>


                  <v-flex md2 lg2 style="margin-left:30px;margin-top:10px" v-if="!uploadingfile">
                    <v-btn class="mx-2" fab dark color="indigo" @click="pickFile">
                      <v-icon dark>fas fa-plus</v-icon>
                    </v-btn>
                  </v-flex>
                  <v-flex md2 lg2 style="margin-left:30px;margin-top:10px" v-if="uploadingfile">
                    <v-progress-circular
                      :rotate="360"
                      :size="100"
                      :width="15"
                      :value="percentageupload"
                      color="primary"
                    >
                      {{percentageupload}}
                    </v-progress-circular>
                  </v-flex>
              </v-layout> 
            </div>
            <div
              v-if="filesexistoruploading"
              class="hidden-lg-only hidden-md-only hidden-xl-only"
              style="width:100%; overflow-x:auto; position:relative"
            >
              <v-layout class="newpostfooter">
                <v-flex xs6 sm3 lg3 style="margin-left:10px" v-for="filesuploaded in filesuploaded" :key="filesuploaded.length">
                  <button type="button" class="close" @click="deletefile(filesuploaded._id)" style="position:absolute;z-index:5;background:black;">
                        <span style="color:white;font-size:30px" aria-hidden="true">&times;</span>
                  </button>
                  <video
                    @click="openmodalfile(filesuploaded.link,filesuploaded.type)"
                    v-if="filesuploaded.type.split('/')[0] === 'video' || filesuploaded.type.split('/')[0] === 'audio'"
                    :id="filesuploaded._id"
                    class="video-js"
                    style="width:150px;height:100px"
                    controls
                    data-setup='{"language":"en"}'
                  >
                    <source :src="filesuploaded.link" :type="filesuploaded.type">
                     <track kind="captions" src="http://example.com/path/to/captions.vtt" srclang="en" label="English" default>

                  </video>
                  <!--video-player 
                          v-if="filesuploaded.type.split('/')[0] === 'video' || filesuploaded.type.split('/')[0] === 'audio'"
                          ref="videoPlayer"
                          :options="playerOptions"
                          
                          :playsinline="true"
                          @play="onPlayerPlay($event)"
                          @pause="onPlayerPause($event)"
                          @ended="onPlayerEnded($event)"
                          @loadeddata="onPlayerLoadeddata($event)"
                          @waiting="onPlayerWaiting($event)"v-if="uploadingfile"
                          @playing="onPlayerPlaying($event)"
                          @timeupdate="onPlayerTimeupdate($event)"
                          @canplay="onPlayerCanplay($event)"
                          @canplaythrough="onPlayerCanplaythrough($event)"
                          @ready="playerReadied"
                          @statechanged="playerStateChanged($event)">
                          <source :src="filesuploaded.link" :type="filesuploaded.type">
                  </video-player-->
                  <v-img 
                    @click="openmodalfile(filesuploaded.link,filesuploaded.type)"
                    v-else-if="filesuploaded.type.split('/')[0] === 'image'"
                    width='150'
                    height='100'
                    :src="filesuploaded.link"
                  ></v-img>
                  <div  class="text-center" v-else>
                      <i class="fas fa-file" style="font-size:50px;margin-top:30px"></i>
                      <br>
                      <label>{{filesuploaded.name}}</label>
                  </div>
                </v-flex>


                <v-flex xs6 sm3 lg3 style="margin-left:10px" v-if="!uploadingfile">
                  <v-btn class="mx-2" fab dark color="indigo" @click="pickFile">
                    <v-icon dark>fas fa-plus</v-icon>
                  </v-btn>
                </v-flex>
                <v-flex xs6 sm3 lg3 v-if="uploadingfile">
                  <v-progress-circular
                    :rotate="360"
                    :size="100"
                    :width="15"
                    :value="percentageupload"
                    color="primary"
                  >
                    {{percentageupload}}
                  </v-progress-circular>
                </v-flex>
              

              
              </v-layout>
            </div>
            <div class="text-center newpostfooter">
              <v-btn color="primary" @click="publishnewpost" :disabled="uploadingfile">{{language==='English'?'Post':'Publicar'}}</v-btn>
            </div>
            
    
            <!--v-layout class="newpostfooter" style="width:200px; overflow:scroll">
              <v-flex xs6 sm2 style="margin-left:10px">
                <video-player
                         ref="videoPlayer"
                         :options="playerOptions"
                         :playsinline="true"
                         @play="onPlayerPlay($event)"
                         @pause="onPlayerPause($event)"
                         @ended="onPlayerEnded($event)"
                         @loadeddata="onPlayerLoadeddata($event)"
                         @waiting="onPlayerWaiting($event)"
                         @playing="onPlayerPlaying($event)"
                         @timeupdate="onPlayerTimeupdate($event)"
                         @canplay="onPlayerCanplay($event)"
                         @canplaythrough="onPlayerCanplaythrough($event)"
                         @ready="playerReadied"
                         @statechanged="playerStateChanged($event)">
                </video-player>
              </v-flex>

              <v-flex xs6 sm2 style="margin-left:10px;">
                <v-img style="height:90px"
                  src="https://cdn.vuetifyjs.com/images/parallax/material2.jpg"
                  gradient="to top right, rgba(100,115,201,.33), rgba(25,32,72,.7)"
                ></v-img>
              </v-flex>

              <v-flex  xs6 sm2 style="margin-left:10px;">
                <v-img style="height:90px"
                  src="https://cdn.vuetifyjs.com/images/parallax/material2.jpg"
                  gradient="to top right, rgba(100,115,201,.33), rgba(25,32,72,.7)"
                ></v-img>
              </v-flex>

              <v-flex  xs6 sm2 style="margin-left:10px;">
                <v-img style="height:90px"
                  src="https://cdn.vuetifyjs.com/images/parallax/material2.jpg"
                  gradient="to top right, rgba(100,115,201,.33), rgba(25,32,72,.7)"
                ></v-img>
              </v-flex>

             <v-flex  xs6 sm2 style="margin-left:10px;">
                <v-img style="height:90px"
                  src="https://cdn.vuetifyjs.com/images/parallax/material2.jpg"
                  gradient="to top right, rgba(100,115,201,.33), rgba(25,32,72,.7)"
                ></v-img>
              </v-flex>


              
            </v-layout-->
        </div>
        <label v-if="postdataid!==null">{{language==='English'?'Post':'Publicación'}}</label>
        <v-divider></v-divider>
        <div class="recentcontainer" v-if="postdataid!==null">
            <div class="newpostheader" style="height:90px">
                <a href="javascript:void(0)" @click="goprofileuser(postdata._id_user.username)">
                    <img :src="postdataid._id_user.photo[0].link" />
                    <span class="name">{{postdataid._id_user.fullname}}</span>
                </a>
                <p>
                    <a class="date" href="javascript:void(0)">{{postdataid.created_at}}</a>
                    <a href="javascript:void(0)">
                      <i class="fa fa-globe" v-if="postdataid.visibility==='public'"></i>
                      <i class="fa fa-user-friends" v-if="postdataid.visibility==='followers'"></i>
                    </a>
                <div class="rightsideofpost">
                    <a class="follow" href="javascript:void(0)">
                    <!--i class="fa fa-star"></i-->
                    </a>
                    <v-menu> 
                      <v-btn icon slot="activator">
                          <v-icon>fas fa-caret-down</v-icon>
                      </v-btn> 
                      <v-list>
                          <v-list-tile v-if="!postdataid.isownerpost">
                              <v-list-tile-content @click="openmodalreport(postdataid._id, postdataid._id_user._id)">
                                  <v-list-tile-title   class="fas fa-exclamation-triangle" style="cursor:pointer">{{language === 'English'?'Report Publication':'Reportar Publicación'}}</v-list-tile-title>
                              </v-list-tile-content>
                          </v-list-tile> 
                          <v-list-tile v-if="postdataid.isownerpost">
                              <v-list-tile-content>
                                  <v-list-tile-title @click="deletepost(postdataid._id, true)"  class="fas fa-trash-alt" style="cursor:pointer">{{language === 'English'?'Delete':'Borrar'}}</v-list-tile-title>
                              </v-list-tile-content>
                          </v-list-tile>  
                      </v-list>
                  </v-menu>
                </div>
                </p>
            </div>
            <div class="newpost">
            <div class="postcontent">
                <p align="justify">{{postdataid.description}}</p>
            </div>
            <div
              v-if="postdataid.files.length >= 2"
              class="hidden-sm-only hidden-xs-only"
              style="width:100%; position:relative;"
            >
              <v-layout class="newpostfooter" row wrap>
                <v-flex md2 lg2 style="margin-left:30px;margin-top:10px" v-for="files in postdataid.files" :key="files.length">
                    <video
                      v-if="files.type.split('/')[0] === 'video' || files.type.split('/')[0] === 'audio'"
                      :id="files._id"
                      class="video-js"
                      style="width:150px;height:100px"
                      @click="openmodalfile(files.link,files.type)"
                    >
                      <source :src="files.link" :type="files.type">
                    </video>
                    <!--video-player 
                            v-if="filesuploaded.type.split('/')[0] === 'video' || filesuploaded.type.split('/')[0] === 'audio'"
                            ref="videoPlayer"
                            :options="playerOptions"
                            
                            :playsinline="true"
                            @play="onPlayerPlay($event)"
                            @pause="onPlayerPause($event)"
                            @ended="onPlayerEnded($event)"
                            @loadeddata="onPlayerLoadeddata($event)"
                            @waiting="onPlayerWaiting($event)"
                            @playing="onPlayerPlaying($event)"
                            @timeupdate="onPlayerTimeupdate($event)"
                            @canplay="onPlayerCanplay($event)"
                            @canplaythrough="onPlayerCanplaythrough($event)"
                            @ready="playerReadied"
                            @statechanged="playerStateChanged($event)">
                            <source :src="filesuploaded.link" :type="filesuploaded.type">
                    </video-player-->
                    <v-img 
                      v-else-if="files.type.split('/')[0] === 'image'"
                      width='150'
                      height='100'
                      :src="files.link"
                      @click="openmodalfile(files.link,files.type)"
                    ></v-img>
                    <div class="text-center" v-else style="cursor:pointer" @click="openmodalfile(files.link,files.type)">
                      <i class="fas fa-file" style="font-size:50px;margin-top:30px"></i>
                      <br>
                      <label>{{files.name}}</label>
                    </div>
                  </v-flex>
                  </v-flex>
              </v-layout> 
            </div>
            <div
              v-if="postdataid.files.length >= 2"
              class="hidden-lg-only hidden-md-only hidden-xl-only"
              style="width:100%; overflow-x:auto; position:relative"
            >
              <v-layout class="newpostfooter">
                <v-flex xs6 sm3 lg3 style="margin-left:10px" v-for="files in postdataid.files" :key="files.length">
                  <video
                    v-if="files.type.split('/')[0] === 'video' || files.type.split('/')[0] === 'audio'"
                    :id="files._id"
                    class="video-js"
                    style="width:140px;height:100px"
                    controls
                  >
                    <source :src="files.link" :type="files.type">
                     <track kind="captions" src="http://example.com/path/to/captions.vtt" srclang="en" label="English" default>

                  </video>
                  <!--video-player 
                          v-if="filesuploaded.type.split('/')[0] === 'video' || filesuploaded.type.split('/')[0] === 'audio'"
                          ref="videoPlayer"
                          :options="playerOptions"
                          
                          :playsinline="true"
                          @play="onPlayerPlay($event)"
                          @pause="onPlayerPause($event)"
                          @ended="onPlayerEnded($event)"
                          @loadeddata="onPlayerLoadeddata($event)"
                          @waiting="onPlayerWaiting($event)"
                          @playing="onPlayerPlaying($event)"
                          @timeupdate="onPlayerTimeupdate($event)"
                          @canplay="onPlayerCanplay($event)"
                          @canplaythrough="onPlayerCanplaythrough($event)"
                          @ready="playerReadied"
                          @statechanged="playerStateChanged($event)">
                          <source :src="filesuploaded.link" :type="filesuploaded.type">
                  </video-player-->
                  <v-img 
                    v-else-if="files.type.split('/')[0] === 'image'"
                    width='150'
                    height='100'
                    @click="openmodalfile(files.link,files.type)"
                    :src="files.link"
                  ></v-img>
                  <div class="text-center" v-else @click="openmodalfile(files.link,files.type)" style="cr">
                      <i class="fas fa-file" style="font-size:50px;margin-top:30px"></i>
                      <br>
                      <label>{{files.name}}</label>
                  </div>
                </v-flex>
              </v-layout>
            </div>
            <div class="postcontent tc" v-if="postdataid.files.length === 1">
              <div :class="files.type.split('/')[0] === 'image' || files.type.split('/')[0] === 'video' || files.type.split('/')[0] === 'audio' ? 'embed-responsive embed-responsive-16by9':''" v-for="files in postdata.files" :key="files.length">
                <v-img 
                    class="embed-responsive-item"
                    v-if="files.type.split('/')[0] === 'image'"
                    :src="files.link"
                    
                ></v-img>
                <video
                    v-else-if="files.type.split('/')[0] === 'video' || files.type.split('/')[0] === 'audio'"
                    :id="files._id"
                    class="video-js embed-responsive-item"
                    controls
                    data-setup='{"language":"en"}'
                  >
                    <source :src="files.link" :type="files.type">
                     <track kind="captions" src="http://example.com/path/to/captions.vtt" srclang="en" label="English" default>
                  </video>
                  <div class="text-center" v-else @click="openmodalfile(files.link,files.type)" style="cursor:pointer">
                      <i class="fas fa-file" style="font-size:50px; cursor:pointer"></i>
                      <br>
                      <label style="margin-right:10px;cursor:pointer">{{files.name}}</label>
                  </div>
              </div>
                <!--iframe src="https://www.facebook.com/plugins/video.php?href=https%3A%2F%2Fwww.facebook.com%2Fecosia%2Fvideos%2F10154359809121611%2F&show_text=0&width=400" width="400" height="400" style="border:none;overflow:hidden" scrolling="no" frameborder="0" allowTransparency="true" allowFullScreen="true"></iframe-->
            </div>
            </div>
            <ul class="newpostfooter nav nav-tabs nav-justified">
            <li @click="saveanddeletelikes(index, postdataid._id, postdataid.userlike.length>0?true:false, postdataid._id_user._id, true)">
                <a href="javascript:void(0)" :style="postdataid.userlike.length>0?'color:#007bff':''">
                <i class="fa fa-thumbs-up" ></i>
                <span>{{language==='English'?'Like':'Me Gusta'}}</span>
                </a>
            </li>
            <li>
                <a title="Leave a comment" @click="openmodalcomments(postdataid._id,postdataid._id_user._id)">
                  <i class="fa fa-comments"></i>
                  <span>{{language==='English'?'Comments':'Comentarios'}}</span>
                </a>
            </li>
            <!--li>
                <a href="javascript:void(0)" title="Send this to friends or post it to your timeline">
                <i class="fa fa-share"></i>
                <span>Share</span>
                </a>
            </li-->
            </ul>
            <ul class="community-counter nav nav-tabs nav-justified">
            <li>
                <a @click="openmodallikeusers(postdataid._id)">
                  <i class="fa fa-thumbs-up"></i>
                  <span>{{abbreviateNumber(postdataid.countlikes)}}</span>
                </a>
            </li>
            <!--li>
                <a href="javascript:void(0)">
                  <i class="fa fa-comments"></i>
                  <span>{{postdata.countcomments===undefined ? 0 :abbreviateNumber(postdata.countcomments)}}</span>
                </a>
            </li-->
            <!--li>
                <a href="javascript:void(0)">
                <i class="fa fa-share"></i>
                <span>4</span>
                </a>
            </li-->
            </ul>
            <!--div class="commentpost">
            <div class="input-group">
                <a href="javascript:void(0)">
                <img src="//i.imgur.com/5jInimY.jpg" />
                </a>

                <textarea class="form-control" placeholder="Write a comment..."></textarea>
                <div class="input-group-btn">
                <a class="btn btn-default" href="javascript:void(0)">
                    <i class="fa fa-smile-o"></i>
                </a>
                <a class="btn btn-default" href="javascript:void(0)">
                    <i class="fa fa-picture-o"></i>
                </a>
                <a class="btn btn-default" href="javascript:void(0)">
                    <i class="fa fa-gift"></i>
                </a>
                </div>
            </div>
            </div-->
        </div>
        <!--div class="recentcontainer">
            <div class="newpostheader">
            <a href="javascript:void(0)">
                <img src="//i.imgur.com/5jInimY.jpg" />
                <span class="name">First Last</span>
            </a>
            <span>shared <a href="javascript:void(0)">Demyos's</a> <a href="javascript:void(0)">post</a>.</span>
            <p>
                <a class="date" href="javascript:void(0)">44 mins</a>
                <a href="javascript:void(0)">
                <i class="fa fa-globe"></i>
                </a>
            <div class="rightsideofpost">
                <a class="follow" href="javascript:void(0)">
                <i class="fa fa-star"></i>
                </a>
                <a class="personpostmenu" href="javascript:void(0)">
                <i class="fa fa-caret-down"></i>
                </a>
            </div>
            </p>
        </div>
            <div class="newpost">
            <div class="postcontent">
                Lorem ipsum dolor sit amet, consectetur adipisicing elit. Cupiditate sunt quasi in quam asperiores! Optio voluptate impedit eos ex nisi, molestias facilis sint cupiditate, dolores veritatis cum? Enim vel, qui!
            </div>
            </div>
            <ul class="newpostfooter nav nav-tabs nav-justified">
            <li>
                <a href="javascript:void(0)">
                <i class="fa fa-thumbs-up"></i>
                <span>Like</span>
                </a>
            </li>
            <li>
                <a href="javascript:void(0)" title="Leave a comment">
                <i class="fa fa-comment-o"></i>
                <span>Comment</span>
                </a>
            </li>
            <li>
                <a href="javascript:void(0)" title="Send this to friends or post it to your timeline">
                <i class="fa fa-share"></i>
                <span>Share</span>
                </a>
            </li>
            </ul>
            <ul class="community-counter nav nav-tabs nav-justified">
            <li>
                <a href="javascript:void(0)">
                <i class="fa fa-thumbs-up"></i>
                <span>1</span>
                </a>
            </li>
            <li>
                <a href="javascript:void(0)">
                <i class="fa fa-comment-o"></i>
                <span>3</span>
                </a>
            </li>
            <li>
                <a href="javascript:void(0)">
                <i class="fa fa-share"></i>
                <span>4</span>
                </a>
            </li>
            </ul>
            <div class="commentpost">
            <div class="input-group">
                <a href="javascript:void(0)">
                <img src="//i.imgur.com/5jInimY.jpg" />
                </a>

                <textarea class="form-control" placeholder="Write a comment..."></textarea>
                <div class="input-group-btn">
                <a class="btn btn-default" href="javascript:void(0)">
                    <i class="fa fa-smile-o"></i>
                </a>
                <a class="btn btn-default" href="javascript:void(0)">
                    <i class="fa fa-picture-o"></i>
                </a>
                <a class="btn btn-default" href="javascript:void(0)">
                    <i class="fa fa-gift"></i>
                </a>
                </div>
            </div>
            </div>
        </div-->
        <!--div class="recentcontainer" v-for="postdata in postdata" :key="postdata.length">
          <div class="newpostheader">
            <a href="javascript:void(0)">
                <img src="//i.imgur.com/5jInimY.jpg" />
                <span class="name">First Last</span>
            </a>
            <p>
                <a class="date" href="javascript:void(0)">44 mins</a>
                <a href="javascript:void(0)">
                <i class="fa fa-globe"></i>
                </a>
            <div class="rightsideofpost">
                <a class="follow" href="javascript:void(0)">
                <i class="fa fa-star"></i>
                </a>
                <a class="personpostmenu" href="javascript:void(0)">
                <i class="fa fa-caret-down"></i>
                </a>
            </div>
            </p>
        </div>
            <div class="newpost">
            <div class="postcontent">
                {{postdata.description}}
                <div class="tc">
                <iframe src="https://www.facebook.com/plugins/video.php?href=https%3A%2F%2Fwww.facebook.com%2Fecosia%2Fvideos%2F10154359809121611%2F&show_text=0&width=400" width="400" height="400" style="border:none;overflow:hidden" scrolling="no" frameborder="0" allowTransparency="true" allowFullScreen="true"></iframe>
                </div>
            </div>
            </div>
            <ul class="newpostfooter nav nav-tabs nav-justified">
            <li>
                <a href="javascript:void(0)">
                <i class="fa fa-thumbs-up"></i>
                <span>Like</span>
                </a>
            </li>
            <li>
                <a href="javascript:void(0)" title="Leave a comment">
                <i class="fa fa-comment-o"></i>
                <span>Comment</span>
                </a>
            </li>
            <li>
                <a href="javascript:void(0)" title="Send this to friends or post it to your timeline">
                <i class="fa fa-share"></i>
                <span>Share</span>
                </a>
            </li>
            </ul>
            <ul class="community-counter nav nav-tabs nav-justified">
            <li>
                <a href="javascript:void(0)">
                <i class="fa fa-thumbs-up"></i>
                <span>1</span>
                </a>
            </li>
            <li>
                <a href="javascript:void(0)">
                <i class="fa fa-comment-o"></i>
                <span>3</span>
                </a>
            </li>
            <li>
                <a href="javascript:void(0)">
                <i class="fa fa-share"></i>
                <span>4</span>
                </a>
            </li>
            </ul>
            <div class="commentpost">
            <div class="input-group">
                <a href="javascript:void(0)">
                <img src="//i.imgur.com/5jInimY.jpg" />
                </a>

                <textarea class="form-control" placeholder="Write a comment..."></textarea>
                <div class="input-group-btn">
                <a class="btn btn-default" href="javascript:void(0)">
                    <i class="fa fa-smile-o"></i>
                </a>
                <a class="btn btn-default" href="javascript:void(0)">
                    <i class="fa fa-picture-o"></i>
                </a>
                <a class="btn btn-default" href="javascript:void(0)">
                    <i class="fa fa-gift"></i>
                </a>
                </div>
            </div>
            </div>
            <infinite-loading @infinite="infiniteHandler" style="display:none"/>
        </div-->
        
        <label v-if="postdata.length>0">{{language==='English'?`My Posts and the people I'm following`:'Mis Publicaciones y de las personas que estoy siguiendo'}}</label>
        <label v-else>{{language==='English'?'No posts, follow someone or write your post':'No hay publicaciones, sigue a alguien o escribe tu publicación'}}</label>
        <v-divider></v-divider>

        <div class="recentcontainer" v-for="(postdata, index) in postdata" :key="postdata.length">
            <div class="newpostheader" style="height:90px">
                <a href="javascript:void(0)" @click="goprofileuser(postdata._id_user.username)">
                    <img :src="postdata._id_user.photo[0].link" />
                    <span class="name">{{postdata._id_user.fullname}}</span>
                </a>
                <p>
                    <a class="date" href="javascript:void(0)">{{postdata.created_at}}</a>
                    <a href="javascript:void(0)">
                      <i class="fa fa-globe" v-if="postdata.visibility==='public'"></i>
                      <i class="fa fa-user-friends" v-if="postdata.visibility==='followers'"></i>
                    </a>
                <div class="rightsideofpost">
                    <a class="follow" href="javascript:void(0)">
                    <!--i class="fa fa-star"></i-->
                    </a>
                    <v-menu> 
                      <v-btn icon slot="activator">
                          <v-icon>fas fa-caret-down</v-icon>
                      </v-btn> 
                      <v-list>
                          <v-list-tile v-if="!postdata.isownerpost">
                              <v-list-tile-content @click="openmodalreport(postdata._id, postdata._id_user._id)">
                                  <v-list-tile-title   class="fas fa-exclamation-triangle" style="cursor:pointer">{{language === 'English'?'Report Publication':'Reportar Publicación'}}</v-list-tile-title>
                              </v-list-tile-content>
                          </v-list-tile> 
                          <v-list-tile v-if="postdata.isownerpost">
                              <v-list-tile-content>
                                  <v-list-tile-title @click="deletepost(postdata._id, false)"  class="fas fa-trash-alt" style="cursor:pointer">{{language === 'English'?'Delete':'Borrar'}}</v-list-tile-title>
                              </v-list-tile-content>
                          </v-list-tile>  
                      </v-list>
                  </v-menu>
                </div>
                </p>
            </div>
            <div class="newpost">
            <div class="postcontent">
                <p align="justify">{{postdata.description}}</p>
            </div>
            <div
              v-if="postdata.files.length >= 2"
              class="hidden-sm-only hidden-xs-only"
              style="width:100%; position:relative;"
            >
              <v-layout class="newpostfooter" row wrap>
                <v-flex md2 lg2 style="margin-left:30px;margin-top:10px" v-for="files in postdata.files" :key="files.length">
                    <video
                      @click="openmodalfile(files.link,files.type)"
                      v-if="files.type.split('/')[0] === 'video' || files.type.split('/')[0] === 'audio'"
                      :id="files._id"
                      class="video-js"
                      style="width:150px;height:100px;cursor:pointer"
                      
                    >
                      <source :src="files.link" :type="files.type">
                    </video>
                    <!--video-player 
                            v-if="filesuploaded.type.split('/')[0] === 'video' || filesuploaded.type.split('/')[0] === 'audio'"
                            ref="videoPlayer"
                            :options="playerOptions"
                            
                            :playsinline="true"
                            @play="onPlayerPlay($event)"
                            @pause="onPlayerPause($event)"
                            @ended="onPlayerEnded($event)"
                            @loadeddata="onPlayerLoadeddata($event)"
                            @waiting="onPlayerWaiting($event)"
                            @playing="onPlayerPlaying($event)"
                            @timeupdate="onPlayerTimeupdate($event)"
                            @canplay="onPlayerCanplay($event)"
                            @canplaythrough="onPlayerCanplaythrough($event)"
                            @ready="playerReadied"
                            @statechanged="playerStateChanged($event)">
                            <source :src="filesuploaded.link" :type="filesuploaded.type">
                    </video-player-->
                    <v-img
                      @click="openmodalfile(files.link,files.type)"
                      v-else-if="files.type.split('/')[0] === 'image'"
                      width='150'
                      height='100'
                      :src="files.link"
                      style="cursor:pointer"
                    ></v-img>
                    <div class="text-center" v-else @click="openmodalfile(files.link,files.type)" style="cursor:pointer">
                      <i class="fas fa-file" style="font-size:50px;margin-top:30px"></i>
                      <br>
                      <label>{{files.name}}</label>
                    </div>
                  </v-flex>
                  </v-flex>
              </v-layout> 
            </div>
            <div
              v-if="postdata.files.length >= 2"
              class="hidden-lg-only hidden-md-only hidden-xl-only"
              style="width:100%; overflow-x:auto; position:relative"
            >
              <v-layout class="newpostfooter">
                <v-flex xs6 sm3 lg3 style="margin-left:10px" v-for="files in postdata.files" :key="files.length">
                  <div  
                    v-if="files.type.split('/')[0] === 'video' || files.type.split('/')[0] === 'audio'">
                    <video
                      :id="files._id"
                      class="video-js"
                      style="width:150px;height:100px"
                      controls
                      data-setup='{"language":"en"}'
                      
                    >
                      <source :src="files.link" :type="files.type">
                      <track kind="captions" src="http://example.com/path/to/captions.vtt"  srclang="en" label="English" default>

                    </video>
                   </div>
                  <!--video-player 
                          v-if="filesuploaded.type.split('/')[0] === 'video' || filesuploaded.type.split('/')[0] === 'audio'"
                          ref="videoPlayer"
                          :options="playerOptions"
                          
                          :playsinline="true"
                          @play="onPlayerPlay($event)"
                          @pause="onPlayerPause($event)"
                          @ended="onPlayerEnded($event)"
                          @loadeddata="onPlayerLoadeddata($event)"
                          @waiting="onPlayerWaiting($event)"
                          @playing="onPlayerPlaying($event)"
                          @timeupdate="onPlayerTimeupdate($event)"
                          @canplay="onPlayerCanplay($event)"
                          @canplaythrough="onPlayerCanplaythrough($event)"
                          @ready="playerReadied"
                          @statechanged="playerStateChanged($event)">
                          <source :src="filesuploaded.link" :type="filesuploaded.type">
                  </video-player-->
                  <v-img 
                    v-else-if="files.type.split('/')[0] === 'image'"
                    width='150'
                    height='100'
                    :src="files.link"
                    @click="openmodalfile(files.link,files.type)"
                  ></v-img>
                  <div class="text-center" v-else @click="openmodalfile(files.link,files.type)" style="cursor:pointer">
                      <i class="fas fa-file" style="font-size:50px;margin-top:30px"></i>
                      <br>
                      <label>{{files.name}}</label>
                  </div>
                </v-flex>
              </v-layout>
            </div>
            <div class="postcontent tc" v-if="postdata.files.length === 1">
              <div :class="files.type.split('/')[0] === 'image' || files.type.split('/')[0] === 'video' || files.type.split('/')[0] === 'audio' ? 'embed-responsive embed-responsive-16by9':''" v-for="files in postdata.files" :key="files.length">
                <v-img 
                    class="embed-responsive-item"
                    v-if="files.type.split('/')[0] === 'image'"
                    :src="files.link"
                ></v-img>
                <video
                    v-else-if="files.type.split('/')[0] === 'video' || files.type.split('/')[0] === 'audio'"
                    :id="files._id"
                    class="video-js embed-responsive-item"
                    controls
                    data-setup='{"language":"en"}'
                  >
                    <source :src="files.link" :type="files.type">
                     <track kind="captions" src="http://example.com/path/to/captions.vtt" srclang="en" label="English" default>
                  </video>
                  <div class="text-center" v-else @click="openmodalfile(files.link,files.type)" style="cursor:pointer">
                      <i class="fas fa-file" style="font-size:50px; cursor:pointer"></i>
                      <br>
                      <label style="margin-right:10px;cursor:pointer">{{files.name}}</label>
                  </div>
              </div>
                <!--iframe src="https://www.facebook.com/plugins/video.php?href=https%3A%2F%2Fwww.facebook.com%2Fecosia%2Fvideos%2F10154359809121611%2F&show_text=0&width=400" width="400" height="400" style="border:none;overflow:hidden" scrolling="no" frameborder="0" allowTransparency="true" allowFullScreen="true"></iframe-->
            </div>
            </div>
            <ul class="newpostfooter nav nav-tabs nav-justified">
            <li @click="saveanddeletelikes(index, postdata._id, postdata.userlike.length>0?true:false, postdata._id_user._id, false)">
                <a href="javascript:void(0)" :style="postdata.userlike.length>0?'color:#007bff':''">
                <i class="fa fa-thumbs-up" ></i>
                <span>{{language==='English'?'Like':'Me Gusta'}}</span>
                </a>
            </li>
            <li>
                <a title="Leave a comment" @click="openmodalcomments(postdata._id,postdata._id_user._id)">
                  <i class="fa fa-comments"></i>
                  <span>{{language==='English'?'Comments':'Comentarios'}}</span>
                </a>
            </li>
            <!--li>
                <a href="javascript:void(0)" title="Send this to friends or post it to your timeline">
                <i class="fa fa-share"></i>
                <span>Share</span>
                </a>
            </li-->
            </ul>
            <ul class="community-counter nav nav-tabs nav-justified">
            <li>
                <a @click="openmodallikeusers(postdata._id)">
                  <i class="fa fa-thumbs-up"></i>
                  <span>{{abbreviateNumber(postdata.countlikes)}}</span>
                </a>
            </li>
            <!--li>
                <a href="javascript:void(0)">
                  <i class="fa fa-comments"></i>
                  <span>{{postdata.countcomments===undefined ? 0 :abbreviateNumber(postdata.countcomments)}}</span>
                </a>
            </li-->
            <!--li>
                <a href="javascript:void(0)">
                <i class="fa fa-share"></i>
                <span>4</span>
                </a>
            </li-->
            </ul>
            <!--div class="commentpost">
            <div class="input-group">
                <a href="javascript:void(0)">
                <img src="//i.imgur.com/5jInimY.jpg" />
                </a>

                <textarea class="form-control" placeholder="Write a comment..."></textarea>
                <div class="input-group-btn">
                <a class="btn btn-default" href="javascript:void(0)">
                    <i class="fa fa-smile-o"></i>
                </a>
                <a class="btn btn-default" href="javascript:void(0)">
                    <i class="fa fa-picture-o"></i>
                </a>
                <a class="btn btn-default" href="javascript:void(0)">
                    <i class="fa fa-gift"></i>
                </a>
                </div>
            </div>
            </div-->
        </div>
        <infinite-loading @infinite="infiniteHandler" style="display:none"/>
        </div>
        <div class="thirdcol-content" style="margin-top:28px">
        <div class="section-content" v-if="session && userdata">
            <hr>
            
            <a href="javascript:void(0)">
            
            </a>
            <a href="javascript:void(0)">
            <img :src="userdata.photo" />
            </a>
            <p>
            <a href="javascript:void(0)">
                <span>{{userdata.username}}</span>
            </a>
            
            <!--a href="javascript:void(0)">
                <i class="fa fa-comment"></i>
                Messages
            </a>
            <a href="javascript:void(0)">
                <i class="fa fa-globe"></i>
                Notifications <span>1</span>
            </a-->
            <hr>
            </p>
            <p>
            <!--a href="javascript:void(0)">
                <i class="fa fa-pencil-square-o"></i>
                Publish
            </a-->
            <a  @click="gotoprojects">
                <i class="fa fa-folder"></i>
                {{language==='English'?'Projects':'Proyectos'}}
            </a>
            <a @click="goprofileuser(userdata.username)">
                <i class="fa fa-user"></i>
                {{language==='English'?'Profile':'Perfil'}}
            </a>
            </p>
        </div>
        
        

        <!--div>
            <a href="javascript:void(0)">Privacy</a> · <a href="javascript:void(0)">Terms</a> · <a href="javascript:void(0)">Advertising</a> · <a href="javascript:void(0)">Ad Choices</a> · <a href="javascript:void(0)">Cookies</a> · <a href="javascript:void(0)">More</a>
            <p>
            Facebook © 2017
            </p>
        </div-->
        </div>
        <!--div class="right-content" style="margin-top:28px">
        <ul v-if="session">
            <li>
                <a href="javascript:void(0)">
                    <img src="https://i.imgur.com/5jInimY.jpg" align="left"> 
                    <b style="margin-left:2px">First Name </b> <span>likes First Name's post</span>
                </a>
            </li>
        </ul>
        <ul>
            <h4>Your Pages</h4>
            <li>
            <a href="javascript:void(0)">
                <img src="https://i.imgur.com/5jInimY.jpg" align="left"> 
                <b>Page Name</b> <span>1</span>
            </a>
            </li>
            <li>
            <a href="javascript:void(0)">
                <img src="https://i.imgur.com/5jInimY.jpg" align="left"> 
                <b>Page Name</b>
            </a>
            </li>
            <li>
            <a href="javascript:void(0)">
                <img src="https://i.imgur.com/5jInimY.jpg" align="left"> 
                <b>Page Name</b> <span>2</span>
            </a>
            </li>
            <h4>Contacts</h4>
            <li>
            <a href="javascript:void(0)">
                <img src="https://i.imgur.com/5jInimY.jpg" align="left"> 
                <b>First Name</b> <i class="fa fa-circle"></i>
            </a>
            </li>
            <li>
            <a href="javascript:void(0)">
                <img src="https://i.imgur.com/5jInimY.jpg" align="left"> 
                <b>First Name</b> <i class="fa fa-circle"></i>
            </a>
            </li>
            <li>
            <a href="javascript:void(0)">
                <img src="https://i.imgur.com/5jInimY.jpg" align="left"> 
                <b>First Name</b> <i class="fa fa-circle"></i>
            </a>
            </li>
            <li>
            <a href="javascript:void(0)">
                <img src="https://i.imgur.com/5jInimY.jpg" align="left"> 
                <b>First Name</b> <i class="fa fa-circle"></i>
            </a>
            </li>
            <li>
            <a href="javascript:void(0)">
                <img src="https://i.imgur.com/5jInimY.jpg" align="left"> 
                <b>First Name</b> <i class="fa fa-circle"></i>
            </a>
            </li>
        </ul>
        </div-->
</div>
</template>
<script>
import {EventBus} from '@/helpers/eventbus/event-bus'
import fbstorage from '@/config/fileserver/firebasestorage'
const alertify = require('alertifyjs')
import Fileuploadpost from '@/models/fileuploadpost'
import env from '@/config/env.example'

import {FileuploadpostService, PostService, ReportService} from '@/services'
import Post from '@/models/post'
import Reports from '@/models/report'
import initVue from '../../../../helpers/initVue'
import InfiniteLoading from 'vue-infinite-loading'
import userlikesmodal from '@/components/Templates/Views/userlikesmodal'
import modalcomments from '@/components/Templates/Views/commentsmodal'
import moment from 'moment'

import {
    mapGetters,
    mapActions
} from 'vuex'
export default {
    data(){
        return{
            //isopenedmodallikeuser:false,
            commentdescriptionreport: '',
            modaldescriptionreport: false,
            modelreport : new Reports(),
            fileuploadpost:new Fileuploadpost(),
            userdata: null,
            newpost: new Post(),
            percentageupload:0,
            session:false,
            postdata : [],
            idpost: '',
            iduser:'',
            filesuploaded:[],
            filesexistoruploading: false,
            uploadingfile:false,
            postdataid: null,
            modalfile: false,
            linkfilechoosed:'',
            typefilechoosed:'',
            playerOptions: {
              autoplay: false,
              muted: false,
              language: 'en',
              playbackRates: [0.7, 1.0, 1.5, 2.0],
              width:'150',
              height:'100'
              /*
              sources: [{
                type: "video/mp4",
                // mp4
                src: "http://vjs.zencdn.net/v/oceans.mp4",
                // webm
                // src: "https://cdn.theguardian.tv/webM/2015/07/20/150716YesMen_synd_768k_vp8.webm"
              }],
              poster: "https://surmon-china.github.io/vue-quill-editor/static/images/surmon-1.jpg"*/,
            },
            language: JSON.parse(localStorage.getItem('language')) !== null ? JSON.parse(localStorage.getItem('language')).language : ''
        }
    },
    created(){
        this.getidentity()
    },
    components: {
        'infinite-loading':InfiniteLoading,
        'userlikesmodal-component': userlikesmodal,
        'modalcomments-component':modalcomments
    },
    mounted(){
        if(this.language === 'English'){
            moment.locale('us')
        }else{
            moment.locale('es')
        }
        this.infiniteHandler()
        this.getpostiddata()
        EventBus.$on('changelanguage',()=>{
            let choosedlanguage = JSON.parse(localStorage.getItem('language'))
            this.language = choosedlanguage.language
            if(this.language === 'English'){
                moment.locale('us')
            }else{
                moment.locale('es')
            }
            //console.log(this.language)
            //console.log(choosedlanguage)
        })
        EventBus.$on('closemodallikeuser',()=>{
          this.idpost = ''
        })
        EventBus.$on('getpostid',(typenotification)=>{
          this.postdataid = null
          this.getpostiddata()
        })
        /*
        setTimeout(() => {
          console.log('dynamic change options', this.player)
          // change src
          // this.playerOptions.sources[0].src = 'https://cdn.theguardian.tv/webM/2015/07/20/150716YesMen_synd_768k_vp8.webm';
          // change item
          // this.$set(this.playerOptions.sources, 0, {
          //   type: "video/mp4",
          //   src: 'https://cdn.theguardian.tv/webM/2015/07/20/150716YesMen_synd_768k_vp8.webm',
          // })
          // change array
          // this.playerOptions.sources = [{
          //   type: "video/mp4",
          //   src: 'https://cdn.theguardian.tv/webM/2015/07/20/150716YesMen_synd_768k_vp8.webm',
          // }]
          this.player.muted(false)
        }, 5000)*/
    },
    computed: {
      player() {
        return this.$refs.videoPlayer.player
      }
    },
    methods:{
      openmodalfile(linkfile,typefile){
        let type = typefile.split('/')[0]
        if(type === 'video'){
          this.linkfilechoosed = linkfile
          this.typefilechoosed = typefile
          this.modalfile=true
        }else if (type=== 'audio'){
          this.linkfilechoosed = linkfile
          this.typefilechoosed = typefile
          this.modalfile=true
        }else if (type=== 'image'){
          this.linkfilechoosed = linkfile
          this.typefilechoosed = typefile
          this.modalfile=true
        }else{
          const link = document.createElement('a')
          link.href = linkfile
          document.body.appendChild(link)
          link.click()
        }
      },
      closemodalfile(){
        this.linkfilechoosed = ''
        this.typefilechoosed = ''
        this.modalfile=false
      },
      openmodalreport(idreport, iduserowner){
        this.modelreport._id_user_owner = iduserowner
        this.modelreport.reports = [{
          _id_post: idreport
        }]
        this.modaldescriptionreport = true
      },
      async savereport(){
        if(this.commentdescriptionreport !==''){
          try{
            this.modelreport.reports[0].description = this.commentdescriptionreport
            this.modelreport.reports[0]._id_user_sender = JSON.parse(localStorage.getItem('iden'))._id,
            this.modelreport.reports[0].name = 'Report Post'
            const res = await ReportService.savereport(this.modelreport)
            const {status} = res
            if(status === 200){
              let datanotifications = {
                path: 'Report Post',
                _id_post: this.modelreport.reports[0]._id_post,
                _id_user_sender:JSON.parse(localStorage.getItem('iden'))._id,
                _id_user_sended: this.modelreport._id_user_owner,
                photo: '/img/alerticon.png',
                description: this.modelreport._id_user_owner + ',' +JSON.parse(localStorage.getItem('iden'))._id
              }
              this.$socket.emit('notificationscomment',datanotifications)
              this.commentdescriptionreport = ''
              this.modelreport = new Reports()
              this.modaldescriptionreport = false
            }
          }catch(err){
            console.log(err)
          }
        }else{
          alertify.error(this.language==='English'?'Write the description to report to the user':'Escriba la descripción para reportar al usuario')
        }
      },
      async getpostiddata(){
        //console.log(this.$route)
        if(this.$route.query.idpost !==undefined){
          try{
            const query = {
              idpost : this.$route.query.idpost
            }
            const res = await PostService.getdataposttoid(query)
            const {data} = res
            let id = JSON.parse(localStorage.getItem('iden'))._id
            data.getdatapost.created_at = moment(data.getdatapost.created_at).fromNow()
            if(String(data.getdatapost._id_user._id) === id){
              data.getdatapost.isownerpost = true
            }else{
              data.getdatapost.isownerpost = false
            }
            this.postdataid = data.getdatapost
          }catch(err){
            console.log(err)
          }
        }
      },
      goprofileuser(username){
        window.location = `${env.host}${username}`
      },
      gotoprojects(){
        this.$router.push('/projects')
      },
      openmodalcomments(idpost, iduser){
        let data = {
          idpost: idpost,
          iduser: iduser
        }
        EventBus.$emit('openmodalcomments',(data))
      },
      openmodallikeusers(idpost){
        this.idpost = idpost
        //this.isopenedmodallikeuser = true
        EventBus.$emit('openmodaluserlike',(idpost))
      },
      saveanddeletelikes(index, idpost, likeme, iduser, isobject){
        let data ={
          _id_user: JSON.parse(localStorage.getItem('iden'))._id,
          _id_post: idpost
        }
        if(!likeme){
          this.$socket.emit('savelikeuser',data)
          let isownerpost = String(iduser)===JSON.parse(localStorage.getItem('iden'))._id
          if(!isownerpost){
            let datanotifications = {
              path: 'Like Post',
              _id_post: idpost,
              _id_user_sender:JSON.parse(localStorage.getItem('iden'))._id,
              _id_user_sended: iduser,
              photo: JSON.parse(localStorage.getItem('user')).photo,
              description: JSON.parse(localStorage.getItem('user')).username
            }
            this.$socket.emit('notificationscomment',datanotifications)
          }
          if(isobject){
            this.postdataid.userlike = [{_id_user:JSON.parse(localStorage.getItem('iden'))._id}]
            this.postdataid.countlikes = this.postdataid.countlikes + 1
          }else {
            this.postdata[index].userlike = [{_id_user:JSON.parse(localStorage.getItem('iden'))._id}]
            this.postdata[index].countlikes = this.postdata[index].countlikes + 1
          }
        }else{
          this.$socket.emit('deletelikeuser',data)
          if(isobject){
            this.postdataid.userlike = []
            this.postdataid.countlikes = this.postdataid.countlikes - 1
          }else{
            this.postdata[index].userlike = []
            this.postdata[index].countlikes = this.postdata[index].countlikes - 1
          }

        }
      },
      deletepost(idpost,isobject){
        let data = {
          idpost:idpost
        }
        this.$socket.emit('deletepost',data)
        if(isobject){
          this.postdataid = null
          //this.getpostdataid()
          console.log('dsdfdsfds')
        }else{
          this.postdata = []
          this.infiniteHandler()
        }
      },
      abbreviateNumber(value) {
          var newValue = value;
          if (value >= 1000) {
              var suffixes = ["", "k", "m", "b","t"];
              var suffixNum = Math.floor( (""+value).length/3 );
              var shortValue = '';
              for (var precision = 2; precision >= 1; precision--) {
                  shortValue = parseFloat( (suffixNum != 0 ? (value / Math.pow(1000,suffixNum) ) : value).toPrecision(precision));
                  var dotLessShortValue = (shortValue + '').replace(/[^a-zA-Z 0-9]+/g,'');
                  if (dotLessShortValue.length <= 2) { break; }
              }
              if (shortValue % 1 != 0)  shortValue = shortValue.toFixed(1);
              newValue = shortValue+suffixes[suffixNum];
          }
          return newValue;
      },
      infiniteHandler: function ($state) {
        let limit = this.postdata.length / 40 + 1;
        let data = {
          page: limit
        }
        PostService.list(data).then(res=>{
          this.loadMore($state, res)
        })
      },
			loadMore: function ($state, response) {
        let id = JSON.parse(localStorage.getItem('iden'))._id
          if(!response.data.post.length <=0){
              if ( response.data.post.length ) {
                  response.data.post.forEach(element=>{
                    let datenew = moment(element.created_at).fromNow()
                    element.created_at = datenew
                    if(String(element._id_user._id) === id){
                      element.isownerpost= true
                    }else{
                      element.isownerpost= false
                    }
                  })
                  this.postdata = this.postdata.concat(response.data.post)
                  //console.log(this.postdata)
                  setTimeout(() => {
                      $state.loaded()
                  }, 3000);
                  /*
                  if ( response.followers.length == this.followers.length ) {
                      $state.complete();
                  }*/
              } else {
                  $state.complete()
              }
          }else{
              $state.complete()
          }
      },
      publishnewpost(){
        if(this.newpost.description !== ''){
          this.newpost._id_user = JSON.parse(localStorage.getItem('iden'))._id
          //console.log(this.newpost)
          //this.newṕost.files = []
          this.filesuploaded.forEach(element => {
            this.newpost.files.push(element)
          });
          //this.newpost.files = this.filesuploaded
          this.$socket.emit('newpost',this.newpost)
          let datanotifications = {
              path: 'Save Post',
							_id_user_sender:this.newpost._id_user,
							photo: JSON.parse(localStorage.getItem('user')).photo,
							description: JSON.parse(localStorage.getItem('user')).username
          }
          this.$socket.emit('save_notification',datanotifications)
          this.newpost = new Post()
          this.newpost.visibility = 'public'
          this.getfiles()
          this.postdata = []
          this.infiniteHandler()
        }else{
          alertify.error(this.language==='English'?'Write your post you want to publish.':'Escriba su post que desea publicar.')
        }
      },
      async deletefile(idfile){
        try{
          let query={
            idfile:idfile
          }
          const res = await FileuploadpostService.deletefile(query)
          const { data } = res
          let datadeleted = data.success === true
          if(datadeleted){
            this.getfiles()
          }
        }catch(err){
          console.log(err)
        }
      },
      async getfiles(){
        try{
          const res = await FileuploadpostService.list()
          const { data } = res
          this.filesuploaded = data.files
          if(this.filesuploaded.length>0){
            this.filesexistoruploading = true
          }else{
            this.filesexistoruploading = false
          }

        }catch(err){
          console.log(err)
        }
      },
      makeid(length) {
        var result           = '';
        var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        var charactersLength = characters.length;
        for ( var i = 0; i < length; i++ ) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
        }
        return result;
      },
      pickFile () {
        this.$refs.filepost.click()
      },
      getFileExtension(filename) {
        return filename.slice((filename.lastIndexOf(".") - 1 >>> 0) + 2);
      },
      onFilePicked (e) {
        let id = JSON.parse(localStorage.getItem('iden'))._id
        this.uploadingfile = true
        this.filesexistoruploading = true
        const files = e.target.files
        let self = this
        let name = self.makeid(6)
						let ext = this.getFileExtension(files[0].name)
						if(ext!==''){
              const storageRef = fbstorage.ref(`${id}/post/uploadfiles/${name}.${ext}`)
              const task = storageRef.put(files[0])
              task.on('state_changed',snapshot=>{
                let percentage = (snapshot.bytesTransferred/snapshot.totalBytes)*100
                self.percentageupload = percentage.toFixed(0)
              },(error)=>{
                alertify.error(error)
              },
              ()=>{
              
                task.snapshot.ref.getDownloadURL().then(url => {
                let imgdata = {
                  name : name+'.'+ext,
                  link: url,
                  type: files[0].type
                }
                  self.fileuploadpost = imgdata
                  FileuploadpostService.uploadfiles(self.fileuploadpost).then(res=>{
                    this.getfiles()
                    self.percentageupload = 0
                    self.uploadingfile = false
                  //this.axios.put(`users/edituser/${id}/${self.emailedit}/${self.usernameedit}/${self.passwordempty}/${token}`, self.users)
                  //.then(() =>{
                    
                    //this.getuser()
                    //EventBus.$emit('getuser')
                    //console.log(res)
                    //this.successedit= true
                    /*
                    if(this.passwordedit === true){
                      this.messageedit = 'Datos Editados'
                    }else{
                      this.messageedit = 'Datos Editados'
                    }*/
                    

                  })

                  .catch((err) =>{
                    self.percentageupload = 0
                    self.uploadingfile = false
                  })
                //self.percentage = 100
                //self.loadingsaving = false
                //self.modalfileuploaded = false
                //this.filesproject = new FilesProjects()

                })
              })
            }
		  },
      // listen event
      playvideo(){
        this.$refs.videoPlayer.player
      },
      onPlayerPlay(player) {
        // console.log('player play!', player)
      },
      onPlayerPause(player) {
        // console.log('player pause!', player)
      },
      onPlayerEnded(player) {
        // console.log('player ended!', player)
      },
      onPlayerLoadeddata(player) {
        // console.log('player Loadeddata!', player)
      },
      onPlayerWaiting(player) {
        // console.log('player Waiting!', player)
      },
      onPlayerPlaying(player) {
        // console.log('player Playing!', player)
      },
      onPlayerTimeupdate(player) {
        // console.log('player Timeupdate!', player.currentTime())
      },
      onPlayerCanplay(player) {
        // console.log('player Canplay!', player)
      },
      onPlayerCanplaythrough(player) {
        // console.log('player Canplaythrough!', player)
      },
      // or listen state event
      playerStateChanged(playerCurrentState) {
        // console.log('player current update state', playerCurrentState)
      },
      // player is ready
      playerReadied(player) {
        // seek to 10s
        console.log('example player 1 readied', player)
        player.currentTime(0)
        // console.log('example 01: the player is readied', player)
      },
        getidentity(){
            let identity = initVue.getIdentity().identity
            let token = initVue.getIdentity().token
            this.session = initVue.isLogged(identity, token)
            if(this.session){
                this.getuserdata()
            }else{
              this.$router.back()
            }
            //console.log(this.session)
        },
        getuserdata(){
            this.newpost.visibility = 'public'
            this.userdata = JSON.parse(localStorage.getItem('user'))
            this.getfiles()
        }
    }
}
</script>
<style scoped>
    .containerimg {
        text-align: center;
        width: 96%;
        max-width: 960px;
        margin: 0 auto;
    }
    .containerimg img {
        width: 100%;
        height: 400px;
    }
    @media (max-width: 767px) {
        .containerimg img {
             width: 80%;
            height: 200px;
        }
    }
    .filters{
        padding-left: 35px;
    }
    .filters ul{
        padding-left:0;margin-bottom:30px
    }
    @media (max-width: 767px) {
        .div-list {
            overflow:auto
        }
    }
    @media (max-width: 991px){
        .filters ul{
            margin-bottom:20px
        }
    }
    .filters ul li{
        display:inline-block;
        margin-right:40px;font-size:13px;
        font-weight:400;text-transform:uppercase;
        color:#05364d;cursor:pointer;
        -webkit-transition:all 0.4s ease 0s;
        -moz-transition:all 0.4s ease 0s;
        -o-transition:all 0.4s ease 0s;transition:all 0.4s ease 0s
    }
    .filters ul li:hover,.filters ul li.active{
        color:#1345e6
    }
   

</style>

<style lang="stylus" scoped>
// Varaibles
bg = #e9ebee
postbg = #f6f7f9
leftcontpos = 250px

// Global
body
  background-color bg
  
textarea, .form-control
  border 0 
  border-radius 0
  resize none

// Top Menubar
.topbar
  position fixed
  top 0
  left 0
  right 0
  z-index 1
  padding 6px 26px
  height 42px
  background #3b5e95
  border-bottom: 1px solid #294c7b
  overflow hidden
  .right-group
    float right
    .link-group
      position relative
      top -4px
      display inline-block
      padding 0
      a
        padding 9px 8px
        color white
        font-size 12px
        img
          display inline-block
          width 24px
          height 24px
          margin-right 9px
      a:hover
        background #355486
        text-decoration none
    .link-group:nth-child(2)
      a
        margin-right 16px
        border-left 1px solid #355485
        
    .notification-group
      display inline-block
      position relative
      top 3px
      .link-group
        a
          margin 0
          border 0
      a 
        color #17253c
        font-size 21px
      a:hover
        color #111
        background transparent
    .link-group:nth-child(4)
      a
        margin-left 16px
        border-left 1px solid #355485
        
  .search-box
    display inline-block
    width calc(100vw - 72%)
    .input-group
      *
        font-size 12px
        height 25px
        border 1px solid white
        background white
        outline 0
      button
        color #7a7a7a
        transition all ease 150ms
      button:hover
        color #000

// Content Sections
  .left-content
    left 0

  .left-content
    position fixed
    top 42px
    bottom 0
    width leftcontpos
    background bg
    overflow auto
    .global-links
      padding 10px
      margin-left 10px
      a
        display inline-block
        color black
        font-size 12px
        width 100%
        padding 2px 8px
        img
          width 20px
          height 20px
          margin-right 6px
      .counter
        float right
        color #90949c
        .fa-ellipsis-h
          font-size 20px
      .activepage
        padding-top 5px
        background white
        border-radius 2px
        border 1px solid #dddfe2
    .group-content
      h4
        margin 20px 0 8px 0
        font-size 13px
        color #444
        text-transform uppercase
     a:last-child
       .fa-caret-down
         margin-right: 12px

  .feed-content
    position absolute
    top 42px
    bottom 0
    right 0
    padding 12px 7px
    background bg
    overflow auto
    .recentcontainer
      border-radius 2px
      border 1px solid #dddfe2
      margin-bottom 15px
      overflow hidden
      .newpostheader, .newpostfooter
        padding 4px 5px
        background postbg
        li
          display inline-block
          
          text-align center
        li:first-child
          float left
        li:last-child
          float rght
        h4
          font-size 14px
          margin 10px 5px
          color #666
        a:first-child
          margin-right 5px
        a
          font-size 14px
          img 
            width 40px
            height 40px
            margin 5px 5px 0 5px
          .name
            position relative
            top -6px
          .fa
            display inline-block
            margin 5px
        > span
          position relative
          top -6px
          left -4px
          font-size 14px
        p
          position relative
          top -22px
          left 55px
          font-size 12px
          a
            font-size 12px
            color #4b4f56
            margin-right 5px
        .rightsideofpost
          position relative
          top -73px
          float right
          .personpostmenu
            color #4b4f56
        li
          a
            font-size 14px
            color #4b4f56
            margin-right 5px
            .fa
              display inline-block
              margin 5px
      .community-counter
        padding 4px 5px
        background postbg
        li
          a
            font-size 14px
            color #4b4f56
            margin-right 5px
            .fa
              display inline-block
              margin 5px
      .newpost
        textarea, .postcontent
          display inherit
          padding 10px
          width 100%
          height 100%
          background postbg
        .postcontent
          position relative
          margin-top -40px
          padding-bottom 40px
          white-space pre-line
      .newpostfooter
        margin-top 1px
      .commentpost
        display inherit
        background postbg
        margin-top -1px
        img
          margin 10px
          height 40px
        .input-group-btn
          display inline-block
          background white
          a
            margin-top 10px
    .recentcontainer:nth-child(1)
      .newpostfooter
        li:first-child
          .fa
            color #96b756
        li:nth-child(2)
          .fa
            color #f1c04e
        li:last-child a:last-child
          font-size 20px

  .thirdcol-content
    position fixed
    top 42px
    bottom 0
    width leftcontpos
    background bg
    right 0
    display block
    width 30%
    padding 12px 7px
    background bg
    overflow-x auto
    > div > a, > div > p
      font-size 12px
    .section-content
      border-radius 2px
      border 1px solid #dddfe2
      margin 0 0 15px 0
      overflow-y hidden
      padding 4px 5px
      background postbg
      h4:nth-child(1)
        font-size 14px
        margin 6px
        padding 6px
        color #888
        a
          float right
          color #8a8a8a
      p
        a
          display block
          span:not(:first-child)
            display inline-block
            margin-left 4px
            font-size 9px
            padding 1px 2px
            color #545454
            background white
            border 1px solid #b8b8b8
      a
        font-size 14px
        margin-right 5px
        img 
          width 64px
          height 64px
          margin 5px 5px 0 5px
        .fa
          display inline-block
          margin 5px
      p:nth-child(3)
        text-align right
        margin -20px 0 4px 0
        padding 2px
        width 80%
        a
          display inline-block
          position relative
          top -18px
      // pages first links
      p:nth-child(4)
        margin-top -64px
        margin-left 75px
        font-size 12px
        a:not(:nth-child(1))
          font-size 12px
          color #4b4f56
          margin-right 5px
      // pages send links
      p:nth-child(7)
        text-align center
        a
          width 20%
          display inline-block
          color #333
        .fa
          display block
      .activetrend, .activetrend .fa
        color #1273b8
      .trend-feed
        ul
          margin 0 30px
          padding 0
          list-style: square url('http://i.imgur.com/Etzny0O.png');
          li
            font-size 12px
            span:nth-child(1)
              color #999
         div
           a
             float left
             font-size 12px
             margin-top 4px
           a:first-child
             padding 4px 0 0 4px
           a:last-child
             float right
             padding 4px 0 0 4px
    .section-content:nth-child(1) > a:nth-child(2)
      float right
      color #8a8a8a
    .section-content:nth-child(4)
      font-size 12px
      h4
        float left
      a:nth-child(2)
        margin-top 10px
        float right
      div
        padding 5px
        a
          display block
          img
            width 100%
            height auto
        a:hover
          text-decoration none
        div
          padding 5px 5px 0 5px
          font-size 12px
          div
            padding 0
        div:nth-child(3)
          color #878787
        
    .section-content:nth-child(5)
      a
        font-size 12px
    
  .feed-content
    left:0
    right 30%

  .right-content
    display none
    position fixed
    top 42px
    bottom 0
    width leftcontpos
    background bg
    right 0
    width 275px
    padding 12px 7px
    background bg
    overflow-x auto
    border-left 1px solid #a3a3a3
    ul
      list-style none
      padding 0
      margin 0
      height 50%
      overflow auto
      li
        display block
        padding 5px 5px 15px 5px
        width 100%
        border-bottom 1px solid #a3a3a3
        cursor pointer
    ul:first-child
      list-style none
      padding 0
      height 50%
      overflow auto
      li
        display block
        padding 5px 5px 15px 5px
        width 100%
        border-bottom 1px solid #a3a3a3
        cursor pointer
        a
          padding 5px
          font-size 12px
        img
          display inline-block
          width 32px
          height 32px
        b, span
          color #000
        span
          color #545454
        a:hover
          text-decoration none
      li:hover
        background #ccc
    ul:nth-child(2)
      list-style none
      padding 0
      height 50%
      overflow auto
      h4
        font-size 12px
        margin-top 15px
        color #474747
        text-transform uppercase
      li
        display block
        padding 5px 5px 15px 5px
        width 100%
        border-bottom 1px solid #a3a3a3
        cursor pointer
        a
          padding 5px
          font-size 12px
        img
          display inline-block
          width 32px
          height 32px
        b, span
          color #000
        span
          display block
          float right
          position relative
          top 8px
          font-size 9px
          padding 1px 2px
          color #545454
          background white
          border 1px solid #b8b8b8
        .fa
          float right
          position relative
          top 8px
          color #11ff00
        a:hover
          text-decoration none
      li:hover
        background #ccc

@media all and (max-width:700px)
  .left-content
    display none
  .feed-content
    left 0
  .topbar
    .right-group
        > .link-group
          display none

@media all and (max-width:1000px)
  .thirdcol-content
    display none
  .feed-content
    right 0
@media all and (min-width:1260px)
  .feed-content
    left:0
    
  .right-content
    right 0
@media all and (min-width:1261px)
  .feed-content
    left:0
  
@media all and (min-width:1260px)
  .feed-content
    left:0
  .thirdcol-content
    
  .right-content
    display block
    
// Misc
.pointer
  cursor pointer
.ib
  display inline-block
.fl
  float left
.fr
  float right
.tc
  text-align center
</style>
